<script lang=ts>
    export let title: string;
    export let imageWidth: string;
    export let imageSrc: string;
</script>

<div class="relative mt-12 sm:mt-16 lg:mt-24">
    <div class="lg:grid lg:grid-flow-row-dense lg:grid-cols-2 lg:gap-8 lg:items-center">
        <div class="lg:col-start-2">
            <h3 class="text-2xl font-extrabold text-gray-900 tracking-tight sm:text-3xl">
                {title}
            </h3>
            <slot></slot>
        </div>

        <div class="mt-10 -mx-4 relative lg:mt-0 lg:col-start-1 px-4">
            <img class="relative mx-auto rounded-lg" width={imageWidth} src={imageSrc} alt="">
        </div>
    </div>
</div>